import {
  Block,
  Settings,
  SettingSectionTitle,
  SettingsFlexbox
} from '@/components/DybrComponents/StyledServicePagesElements';
import TextField from '@/components/FormElements/TextField';
import { ActionButton } from '@/components/Shared/Buttons';
import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { selectActiveProfileAugmented } from '@/store/user/selectors/selectActiveProfileAugmented';
import { updateProfileThunk } from '@/store/user/thunks/updateProfileThunk';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export function ChangeBlogSettings() {
  const dispatch = useDispatch();
  const { activeProfileId } = useActiveProfile();
  const profile = useSelector(state =>
    selectActiveProfileAugmented(state, { activeProfileId })
  );
  const [title, setTitle] = useState('');
  const [token] = useTokenState();
  const isConfirmed = title === profile.blogTitle;

  const handleClick = () => {
    dispatch(
      updateProfileThunk({
        data: { isCommunity: true },
        token,
        activeProfileId
      })
    );
  };

  const ChangeBlogBlock = (
    <Block>
      <SettingsFlexbox>
        <SettingSectionTitle>
          <h4>Операции с дневником</h4>
          <p>Здесь вы можете преобразовать дневник в сообщество</p>
        </SettingSectionTitle>
        <Settings>
          <p>
            Введите название своего дневника, чтобы преобразовать его в
            сообщество.
          </p>
          <br />
          <TextField
            label="название дневника"
            value={title}
            onChange={e => setTitle(e.target.value)}
            touched
          />
          <br />
          <ActionButton onClick={handleClick} disabled={!isConfirmed}>
            Преобразовать в сообщество
          </ActionButton>
        </Settings>
      </SettingsFlexbox>
    </Block>
  );

  return profile.isCommunity ? null : ChangeBlogBlock;
}
